import axios from "axios";

//IMPORT API ROUTE URL
import { UPDATE_SUMMARY_DETAILS } from "./apiRoutes";

const updateSummary = (data) => {
  var postData = new FormData();

  postData.append("current_user_slug", data.current_user_slug);
  postData.append("resource_slug", data.resourceSlug);
  postData.append("profile_bio", data.summary);

  return axios
    .post(UPDATE_SUMMARY_DETAILS, postData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.log(error);
      return false;
    });
};

export default updateSummary;
